module.exports = __webpack_public_path__ + "img/NT3.1f7d2df8.svg";